import * as React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { cssClampValue } from '../utils/common';

const Wrapper = styled.div`
  margin-top: ${cssClampValue(15, 20)};

  a {
    display: flex;
    font-size: ${cssClampValue(14, 18)};
    text-underline-offset: 5px;
    text-decoration-thickness: 1px;
    align-items: center;
    gap: 10px;
  }
`;

type ViewAllLinkProps = {
  link: string;
  children: React.ReactNode;
};

export default function ViewAllLink({ link, children }: ViewAllLinkProps) {
  return (
    <Wrapper>
      <Link to={link}>
        <span>{children}</span>
      </Link>
    </Wrapper>
  );
}
